import React from 'react';
import { Bell, BellOff } from 'lucide-react';
import { useNotificationContext } from '../contexts/NotificationContext';

interface NotificationBellProps {
  variant?: 'mobile' | 'sidebar' | 'header';
}

export const NotificationBell: React.FC<NotificationBellProps> = ({ variant = 'mobile' }) => {
  const { permission, requestPermission, isLoading } = useNotificationContext();

  const handleClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (permission === 'default' || permission === 'denied') {
      await requestPermission();
    }
  };

  const isEnabled = permission === 'granted';
  
  // Mobile variant (for MobileHeader)
  if (variant === 'mobile') {
    return (
      <button
        onClick={handleClick}
        disabled={isLoading}
        className={`w-10 h-10 rounded-full flex items-center justify-center transition-colors ${
          isEnabled
            ? 'bg-yellow-100 hover:bg-yellow-200 text-yellow-600'
            : 'bg-slate-100 hover:bg-slate-200 text-slate-400'
        } ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
        title={isEnabled ? 'Notificaciones activadas' : 'Activar notificaciones'}
      >
        {isLoading ? (
          <div className="w-5 h-5 border-2 border-slate-300 border-t-slate-600 rounded-full animate-spin" />
        ) : isEnabled ? (
          <Bell size={20} />
        ) : (
          <BellOff size={20} />
        )}
      </button>
    );
  }

  // Header variant (for desktop header)
  if (variant === 'header') {
    return (
      <button
        onClick={handleClick}
        disabled={isLoading}
        className={`p-2 rounded-lg transition-colors relative ${
          isEnabled
            ? 'bg-yellow-50 hover:bg-yellow-100 text-yellow-600'
            : 'bg-slate-100 hover:bg-slate-200 text-slate-400'
        } ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
        title={isEnabled ? 'Notificaciones activadas' : 'Activar notificaciones'}
      >
        {isLoading ? (
          <div className="w-5 h-5 border-2 border-slate-300 border-t-slate-600 rounded-full animate-spin" />
        ) : isEnabled ? (
          <Bell size={20} />
        ) : (
          <BellOff size={20} />
        )}
      </button>
    );
  }

  // Sidebar variant (for desktop)
  return (
    <button
      onClick={handleClick}
      disabled={isLoading}
      className={`p-2 rounded-lg transition-colors ${
        isEnabled
          ? 'bg-yellow-500/20 hover:bg-yellow-500/30 text-yellow-400'
          : 'bg-green-800/50 hover:bg-green-700 text-slate-400'
      } ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
      title={isEnabled ? 'Notificaciones activadas' : 'Activar notificaciones'}
    >
      {isLoading ? (
        <div className="w-4 h-4 border-2 border-slate-300 border-t-white rounded-full animate-spin" />
      ) : isEnabled ? (
        <Bell size={18} />
      ) : (
        <BellOff size={18} />
      )}
    </button>
  );
};
